import { useTranslation } from 'react-i18next';

import { RouteSettings } from '../escalations/RouteSettings';
import styles from './AdminSettingsScreen.module.css';

/**
 * Admin settings — `/admin-settings`. System configuration, as opposed to the
 * per-account preferences on `/profile`.
 *
 * One card per area, each headed (IconDisc + title, the design language) by
 * what it configures, with the area's intro inside the card. Escalations is the first (and so far only)
 * area: its routing panel used to sit under the escalations queue, where a
 * supervisor working the queue scrolled past configuration on every visit.
 *
 * Each section gates itself on the permission its endpoints require, and the
 * nav entry is offered only to a session holding at least one of them
 * (`App.tsx`), so the page never renders empty for someone who reached it.
 */

export interface AdminSettingsScreenProps {
  permissions: readonly string[];
}

export function AdminSettingsScreen({ permissions }: AdminSettingsScreenProps) {
  const { t } = useTranslation();
  const canManageEscalations = permissions.includes('escalation.manage');

  return (
    <div className={styles['page']}>
      {canManageEscalations ? (
        <RouteSettings canManage intro={t('adminSettings.escalationsIntro')} />
      ) : null}
    </div>
  );
}
